import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  toogleMenu,
  toggleMobileLeftMenu,
} from "../../../../actions/layoutAction";
import { withRouter } from "../../../../utils/utility";
import * as Icon from "react-feather";
import OctoIcon from "../../../../assets/icons/octo_icon.svg";
import Logo from "../../../../assets/images/logo-new.svg";
import FeatureRequestModal from "../FeatureRequestModal";
import SidebarToggle from "./SidebarToggle";
import "./adminSidebar.scss";

const SIDEBAR_STORAGE_KEY = "meetocto.adminSidebarExpanded";

class AdminLeftMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowChild: [false, false, false, false],
      extended: true,
      featureRequestStatus: false,
    };
  }

  componentDidMount() {
    let extended = true;

    try {
      const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEY);
      if (stored !== null) {
        extended = stored === "1";
      }
    } catch (error) {
      extended = true;
    }

    this.props.toogleMenu(extended);
    this.setState({ extended });
  }

  toggleExtended = () => {
    this.setState((prevState) => {
      const extended = !prevState.extended;
      this.props.toogleMenu(extended);

      try {
        window.localStorage.setItem(SIDEBAR_STORAGE_KEY, extended ? "1" : "0");
      } catch (error) {
        // ignore storage failures
      }

      return { extended };
    });
  };

  toggleSubmenu = (idNumber) => {
    this.setState((prevState) => {
      const isShowChild = [...prevState.isShowChild];
      isShowChild[idNumber] = !isShowChild[idNumber];
      return { isShowChild };
    });
  };

  closeMobileLeftMenu = () => {
    this.props.toggleMobileLeftMenu(null);
  };

  hideFeatureRequestModal = () => {
    this.setState({ featureRequestStatus: false });
  };

  renderNavLabel = (text) => (
    <span className="admin-sidebar__nav-label">{text}</span>
  );

  renderLogoutBtn = (collapsed = false) => (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        this.props.userLogout();
      }}
      className={`admin-sidebar__logout ${
        collapsed ? "admin-sidebar__logout--collapsed" : ""
      }`}
      aria-label="Logout"
      data-sidebar-tooltip={collapsed ? "Logout" : undefined}
    >
      <Icon.LogOut size={18} />
      <span>Logout</span>
    </a>
  );

  renderDesktopNav = (pathname, extended) => (
    <div className="ul-listitemmenu">
      <Link
        to="/admin/dashboard"
        className={
          "itemcomconsub dashboardmenuicon " +
          (pathname === "/admin/dashboard" ? "active" : "")
        }
        data-sidebar-tooltip={!extended ? "My Dashboard" : undefined}
        onClick={this.closeMobileLeftMenu}
      >
        {this.renderNavLabel("My Dashboard")}
      </Link>

      <Link
        to="/admin/my-calendar"
        className={
          "itemcomconsub calendarmenuicon " +
          (pathname === "/admin/my-calendar" ? "active" : "")
        }
        data-sidebar-tooltip={!extended ? "My Calendar" : undefined}
        onClick={this.closeMobileLeftMenu}
      >
        {this.renderNavLabel("My Calendar")}
      </Link>

      {extended ? (
        <a
          className="itemcomcon eventcmenuicon schcdulcmenuiconnos"
          onClick={() => this.toggleSubmenu(3)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              this.toggleSubmenu(3);
            }
          }}
        >
          {this.renderNavLabel("Event")}
        </a>
      ) : (
        <Link
          to="/admin/events/list"
          className={
            "itemcomconsub eventcmenuicon schcdulcmenuiconnos " +
            (pathname === "/admin/events/list" ||
            pathname === "/admin/events/create/list"
              ? "active"
              : "")
          }
          data-sidebar-tooltip="Event"
          onClick={this.closeMobileLeftMenu}
        >
          {this.renderNavLabel("Event")}
        </Link>
      )}

      {extended && this.state.isShowChild[3] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/events/list"
            className={
              "itemcomconsub " + (pathname === "/admin/events/list" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("Event List")}
          </Link>
          <Link
            to="/admin/events/create/list"
            className={
              "itemcomconsub " +
              (pathname === "/admin/events/create/list" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("New Event")}
          </Link>
        </div>
      ) : null}

      {extended ? (
        <a
          className="itemcomcon schcdulcmenuicon"
          onClick={() => this.toggleSubmenu(0)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              this.toggleSubmenu(0);
            }
          }}
        >
          {this.renderNavLabel("Schedule")}
        </a>
      ) : (
        <Link
          to="/admin/scheduled-events"
          className={
            "itemcomconsub schcdulcmenuicon schcdulcmenuiconnos " +
            (pathname === "/admin/vacation" ||
            pathname === "/admin/settings/schedule" ||
            pathname === "/admin/scheduled-events"
              ? "active"
              : "")
          }
          data-sidebar-tooltip="Schedule"
          onClick={this.closeMobileLeftMenu}
        >
          {this.renderNavLabel("Schedule")}
        </Link>
      )}

      {extended && this.state.isShowChild[0] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/vacation"
            className={
              "itemcomconsub " + (pathname === "/admin/vacation" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("Vacation")}
          </Link>
          <Link
            to="/admin/settings/schedule"
            className={
              "itemcomconsub " +
              (pathname === "/admin/settings/schedule" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("Availability")}
          </Link>
          <Link
            to="/admin/scheduled-events"
            className={
              "itemcomconsub " +
              (pathname === "/admin/scheduled-events" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("Scheduled Events")}
          </Link>
        </div>
      ) : null}

      {extended ? (
        <a
          className="itemcomcon staffmenuicon"
          onClick={() => this.toggleSubmenu(1)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              this.toggleSubmenu(1);
            }
          }}
        >
          {this.renderNavLabel("Staff")}
        </a>
      ) : (
        <Link
          to="/admin/staff"
          className={
            "itemcomconsub staffmenuicon " +
            (pathname === "/admin/staff" ? "active" : "")
          }
          data-sidebar-tooltip="Staff"
          onClick={this.closeMobileLeftMenu}
        >
          {this.renderNavLabel("Staff")}
        </Link>
      )}

      {extended && this.state.isShowChild[1] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/staff"
            className={
              "itemcomconsub " + (pathname === "/admin/staff" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("Directory Info")}
          </Link>
        </div>
      ) : null}

      {extended ? (
        <a
          className="itemcomcon crmmenuicon"
          onClick={() => this.toggleSubmenu(2)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              this.toggleSubmenu(2);
            }
          }}
        >
          {this.renderNavLabel("CRM")}
        </a>
      ) : (
        <Link
          to="/admin/customer"
          className={
            "itemcomconsub crmmenuicon " +
            (pathname === "/admin/customer" ||
            pathname === "/admin/booking-history"
              ? "active"
              : "")
          }
          data-sidebar-tooltip="CRM"
          onClick={this.closeMobileLeftMenu}
        >
          {this.renderNavLabel("CRM")}
        </Link>
      )}

      {extended && this.state.isShowChild[2] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/customer"
            className={
              "itemcomconsub " + (pathname === "/admin/customer" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("Customers")}
          </Link>
          <Link
            to="/admin/booking-history"
            className={
              "itemcomconsub " +
              (pathname === "/admin/booking-history" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            {this.renderNavLabel("Booking History")}
          </Link>
        </div>
      ) : null}

      <Link
        to="/integrations"
        className={
          "itemcomconsub calendarmenuicon " +
          (pathname === "/integrations" ? "active" : "")
        }
        data-sidebar-tooltip={!extended ? "Apps Integrations" : undefined}
        onClick={this.closeMobileLeftMenu}
      >
        {this.renderNavLabel("Apps Integrations")}
      </Link>
    </div>
  );

  renderMobileNav = (pathname) => (
    <div className="ul-listitemmenu">
      <Link
        to="/admin/dashboard"
        className={
          "itemcomconsub dashboardmenuicon " +
          (pathname === "/admin/dashboard" ? "active" : "")
        }
        onClick={this.closeMobileLeftMenu}
      >
        My Dashboard
      </Link>
      <Link
        to="/admin/my-calendar"
        className={
          "itemcomconsub calendarmenuicon " +
          (pathname === "/admin/my-calendar" ? "active" : "")
        }
        onClick={this.closeMobileLeftMenu}
      >
        My Calendar
      </Link>
      <a
        className="itemcomcon eventcmenuicon schcdulcmenuiconnos"
        onClick={() => this.toggleSubmenu(3)}
      >
        Event
      </a>
      {this.state.isShowChild[3] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/events/list"
            className={
              "itemcomconsub " + (pathname === "/admin/events/list" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            Event List
          </Link>
          <Link
            to="/admin/events/create/list"
            className={
              "itemcomconsub " +
              (pathname === "/admin/events/create/list" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            New Event
          </Link>
        </div>
      ) : null}
      <a className="itemcomcon schcdulcmenuicon" onClick={() => this.toggleSubmenu(0)}>
        Schedule
      </a>
      {this.state.isShowChild[0] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/vacation"
            className={
              "itemcomconsub " + (pathname === "/admin/vacation" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            Vacation
          </Link>
          <Link
            to="/admin/settings/schedule"
            className={
              "itemcomconsub " +
              (pathname === "/admin/settings/schedule" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            Availability
          </Link>
          <Link
            to="/admin/scheduled-events"
            className={
              "itemcomconsub " +
              (pathname === "/admin/scheduled-events" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            Scheduled Events
          </Link>
        </div>
      ) : null}
      <a className="itemcomcon staffmenuicon" onClick={() => this.toggleSubmenu(1)}>
        Staff
      </a>
      {this.state.isShowChild[1] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/staff"
            className={
              "itemcomconsub " + (pathname === "/admin/staff" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            Directory Info
          </Link>
        </div>
      ) : null}
      <a className="itemcomcon crmmenuicon" onClick={() => this.toggleSubmenu(2)}>
        CRM
      </a>
      {this.state.isShowChild[2] ? (
        <div className="schcdulcsublinks">
          <Link
            to="/admin/customer"
            className={
              "itemcomconsub " + (pathname === "/admin/customer" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            Customers
          </Link>
          <Link
            to="/admin/booking-history"
            className={
              "itemcomconsub " +
              (pathname === "/admin/booking-history" ? "active" : "")
            }
            onClick={this.closeMobileLeftMenu}
          >
            Booking History
          </Link>
        </div>
      ) : null}
      <Link
        to="/integrations"
        className={
          "itemcomconsub calendarmenuicon " +
          (pathname === "/integrations" ? "active" : "")
        }
        onClick={this.closeMobileLeftMenu}
      >
        Apps Integrations
      </Link>
      <div className="mobile_links d-md-none">
        <Link
          to="https://meetocto.freshdesk.com/support/home"
          className="itemcomconsub supportmenuicon"
          target="_blank"
          onClick={this.closeMobileLeftMenu}
        >
          Support
        </Link>
        <Link
          to="/admin/quick-setup-step-one"
          className={
            "itemcomconsub setupmenuicon " +
            (pathname === "/admin/quick-setup-step-one" ? "active" : "")
          }
          onClick={this.closeMobileLeftMenu}
        >
          Quick setup
        </Link>
        <a
          href="#"
          className="itemcomconsub ideasmenuicon"
          onClick={(event) => {
            event.preventDefault();
            this.closeMobileLeftMenu();
            this.setState({ featureRequestStatus: true });
          }}
        >
          Ideas
        </a>
      </div>
    </div>
  );

  render() {
    const { router, layout } = this.props;
    const { pathname } = router.location;
    const { featureRequestStatus, extended } = this.state;

    return (
      <>
        {featureRequestStatus && (
          <FeatureRequestModal
            hideFeatureRequestModal={this.hideFeatureRequestModal}
          />
        )}

        <div
          className={`admin-sidebar-rail d-none d-md-block ${
            extended ? "admin-sidebar-rail--expanded" : "admin-sidebar-rail--collapsed"
          }`}
        >
          <aside
            id="admin-primary-sidebar"
            className={`sidemenu admin-sidebar ${
              extended ? "admin-sidebar--expanded" : "admin-sidebar--collapsed"
            }`}
          >
            <div className="admin-sidebar__inner">
              <div className="admin-sidebar__scroll">
                {this.renderDesktopNav(pathname, extended)}
              </div>
              <div className="admin-sidebar__footer">
                {this.renderLogoutBtn(!extended)}
              </div>
            </div>
          </aside>
          <SidebarToggle expanded={extended} onToggle={this.toggleExtended} />
        </div>

        {/* Backdrop — always in DOM, toggled by CSS class so no remount flash */}
        <div
          className={`admin-sidebar-mobile-backdrop${
            layout.leftMenuActiveClass === "active" ? " is-open" : ""
          }`}
          onClick={() => this.props.toggleMobileLeftMenu(null)}
          aria-hidden="true"
        />

        {/* Mobile sidebar — position controlled by .active class with !important
            so it can't be overridden by the desktop .sidemenu rule */}
        <aside
          className={`sidemenu admin-sidebar admin-sidebar--mobile d-md-none${
            layout.leftMenuActiveClass === "active" ? " active" : ""
          }`}
        >
          <div className="admin-sidebar__inner">
            <div className="mobile_left_topbar d-flex justify-content-between align-items-center">
              <div className="imgs d-flex align-items-center">
                <img className="mobile_full_logo" src={Logo} alt="MeetOcto" />
              </div>
              <button
                type="button"
                className="admin-sidebar-mobile-close"
                aria-label="Close menu"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.toggleMobileLeftMenu(null);
                }}
              >
                <Icon.X size={22} />
              </button>
            </div>
            <div className="admin-sidebar__scroll">
              {this.renderMobileNav(pathname)}
            </div>
            <div className="admin-sidebar__footer">{this.renderLogoutBtn(false)}</div>
          </div>
        </aside>
      </>
    );
  }
}

const actionMethods = {
  toogleMenu: toogleMenu,
  toggleMobileLeftMenu,
};

const mapStateToProps = (state) => ({
  layout: state.layout,
});

export default connect(mapStateToProps, actionMethods)(withRouter(AdminLeftMenu));
